<!--{{ control?.errors | json }}-->

<ng-template #errorsTemplate let-errors="errors">
  <div class="error-container alert alert-danger" *ngIf="errors">
    <div *ngIf="errors.pattern">
      <ng-template #abstractMessage>
        <div class="error" i18n="@@input.errors.pattern">
          Das Feld {{ fieldName }} enthält ein unzulässiges Zeichen.
        </div>
      </ng-template>
      <div class="error" *ngIf="regexMessage; else abstractMessage" [innerHTML]="regexMessage"></div>
    </div>

    <div *ngIf="errors.required">
      <div class="error" i18n="@@input.errors.required"> Das Feld {{ fieldName }} wird benötigt. </div>
    </div>

    <div *ngIf="errors.checkboxRequired">
      <div class="error" i18n="@@input.errors.required_checkbox">
        Bitte akzeptieren Sie diese Bedingung. Haken Sie dazu die Checkbox oben ab.
      </div>
    </div>

    <div *ngIf="errors.minlength">
      <div class="error" i18n="@@input.errors.minlength">
        Bitte geben Sie für {{ fieldName }} einen Wert mit mindestens {{ errors.minlength.requiredLength }} Zeichen ein.
      </div>
    </div>

    <div *ngIf="errors.maxlength">
      <div class="error" i18n="@@input.errors.maxlength">
        Das Feld {{ fieldName }} darf maximal {{ errors.min.min }} Zeichen beinhalten.
      </div>
    </div>

    <div *ngIf="errors.min">
      <div class="error" i18n="@@input.errors.min">
        Das Feld {{ fieldName }} muss mindestens {{ errors.min.min }} Zeichen beinhalten.
      </div>
    </div>

    <div *ngIf="errors.max">
      <div class="error" i18n="@@input.errors.max">
        Bitte geben Sie für {{ fieldName }} maximal {{ errors.max.max }} ein.
      </div>
    </div>

    <div *ngIf="errors.email">
      <div class="error" i18n="@@input.errors.eMail">
        Bitte geben Sie für {{ fieldName }} eine gültige E-Mail-Adresse enthalten.
      </div>
    </div>

    <div *ngIf="errors.number">
      <div class="error" i18n="@@input.errors.number"> Bitte geben Sie für {{ fieldName }} eine Zahl ein. </div>
    </div>

    <div *ngIf="errors.url">
      <div class="error" i18n="@@input.errors.url"> Bitte geben Sie für {{ fieldName }} eine URL ein. </div>
    </div>

    <div *ngIf="errors.date">
      <div class="error" i18n="@@input.errors.date"> Bitte geben Sie für {{ fieldName }} ein Datum ein. </div>
    </div>
    <div *ngIf="errors.creditCardNumber">
      <div class="error" i18n="@@input.errors.creditCardNumber">
        Bitte geben Sie eine gültige Kreditkartennummer an.
      </div>
    </div>
    <div *ngIf="errors.creditCardExpire">
      <div class="error" i18n="@@input.errors.creditCardExpire"> Bitte geben Sie ein gültiges Datum an. </div>
    </div>
    <div *ngIf="errors.creditCardCvc">
      <div class="error" i18n="@@input.errors.creditCardCvc"> Bitte geben Sie einen gültigen Security Code an. </div>
    </div>
    <div *ngIf="errors.bic">
      <div class="error" i18n="@@input.errors.bic"> Bitte geben Sie eine gültige BIC ein. </div>
    </div>
    <div *ngIf="errors.accountNumber">
      <div class="error" i18n="@@input.errors.accountNumber"> Bitte geben Sie eine gültige Kontonummer an. </div>
    </div>
    <div *ngIf="errors.routingNumber">
      <div class="error" i18n="@@input.errors.routingNumber"> Bitte geben Sie eine gültige BLZ an. </div>
    </div>
    <div *ngIf="errors.selectPaymentPlan">
      <div class="error" i18n="@@input.errors.selectPaymentPlan"> Bitte wählen Sie einen Zahlungsplan aus. </div>
    </div>
    <div *ngIf="errors.latinOnly">
      <div class="error" i18n="@@input.errors.latin_only">
        Ungültiger Wert für {{ fieldName }}. Verwenden Sie nur westliche (lateinische) Buchstaben.
      </div>
    </div>
    <div *ngIf="errors.validatePhoneNumber">
      <div class="error" i18n="@@input.errors.validatePhoneNumber">
        Bitte geben Sie eine gültige Telefonnummer an.
      </div>
    </div>
    <div *ngIf="errors.custom">
      <div class="error" [innerHTML]="errors.custom"></div>
    </div>
  </div>
</ng-template>

<ng-template #showDirectError>
  <ng-container *ngIf="errors && !error">
    <ng-container *ngTemplateOutlet="errorsTemplate; context: { errors: errors }"></ng-container>
  </ng-container>
  <ng-container *ngIf="!errors && error">
    <div class="error-container alert alert-danger">
      <div class="error" [innerHTML]="error"></div>
    </div>
  </ng-container>
</ng-template>

<!--If control not exists, display errors directly-->
<ng-container *ngIf="control; else showDirectError">
  <!--  show error if control is touched and invalid-->
  <ng-container *ngIf="control.dirty && control.invalid">
    <ng-container *ngIf="!errors && !error">
      <ng-container *ngTemplateOutlet="errorsTemplate; context: { errors: control.errors }"></ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngTemplateOutlet="showDirectError"></ng-container>
</ng-container>

<!--<div *ngIf="control">-->
<!--  value: {{ control.value | json }}<br />-->
<!--  dirty: {{ control.dirty }}<br />-->
<!--  invalid: {{ control.invalid }}<br />-->
<!--  touched: {{ control.touched }}<br />-->
<!--  errors: {{ control.errors | json }}<br />-->
<!--  <hr/>-->
<!--</div>-->

<!--Show forminator errors until control has no changes (isclean)-->
<ng-container *ngIf="formErrors && formErrors.length && !control.dirty">
  <div *ngFor="let err of formErrors; let i = index">
    <div class="error" (close)="formErrors.splice(i, 1)">
      {{ err.messageI18n }}
    </div>
  </div>
</ng-container>
